import http from '@/http'

const URL = '/admin/rooms'

export const list = (roomId) => {
  return http.get(`${URL}/${roomId}/banners`)
}

export const save = (roomId, formData) => {
  return http.post(`${URL}/${roomId}/banners`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const update = (roomId, bannerId, formData) => {
  return http.post(`${URL}/${roomId}/banners/${bannerId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const destroy = (roomId, bannerId) => {
  return http.delete(`${URL}/${roomId}/banners/${bannerId}`)
}

export default { list, save, update, destroy }
